<template>
  <div>
  <a id="session-logout" style="visibility:hidden;" href="javascript:localStorage.clear(); sessionStorage.clear();window.location.href = '/Login'"></a>
    <!-- SESSION TIMEOUT CONFIRMATION MODAL -->
    <div tabindex="-1" class="modal bs-example-modal-sm" role="dialog" aria-hidden="true" id="sessionLogoutModal" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="color: #00524A;">
          <div class="modal-header"><h4>{{user_lang.attention}} <i class="fa fa-lock"></i></h4></div>
          <div class="modal-body">{{user_lang.expireWarning.replace('%', sessionExpiration - sessionWarning)}}</div>
          <div clss="row">
          <div class="modal-footer" style="">
		  <a href="javascript:;" class="btn btn-primary btn-block btn-lg" style="background-color: #ececec; color: #00524A;" data-dismiss="modal" @click="clickLogoutNo">
		  {{user_lang.cancel}}</a></div>
           <div class="modal-footer" style="border-top: 0; padding-top: 5px;"><a class="btn btn-primary btn-block btn-lg" href="javascript:;" @click="clickLogoutYes">OK</a></div>
           </div>
        </div>
       </div>
    </div>
    <!-- SESSION LOGOUT MESSAGE MODAL -->
    <div tabindex="-1" class="modal bs-example-modal-sm" role="dialog" aria-hidden="true" id="logoutMessageModal" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="color: #00524A;">
          <div class="modal-header"><h4>{{user_lang.attention}}  <i class="fa fa-lock"></i></h4></div>
          <div class="modal-body">{{user_lang.sessionTimedout}}</div>
          <div clss="row">
<!--<div class="modal-footer" style="border-top: 0; padding-top: 5px;">
<a class="btn btn-primary btn-block btn-lg" href="javascript:;" @click="logoutMessageClose">OK</a></div> -->
          </div>
        </div>
       </div>
    </div>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import { locale } from '@/i18n/locale.js'
import okta from '@/helpers/okta'
import storage from '@/helpers/storage'
export default {
  name: 'SessionTimeout',
  data() {
    return {
      lang: locale.lang,
      lang_obj: locale.lang_obj,
      sessionIntervalID: 0,
      sessionLastActivity: 0,
      sessionDialogOpen: false,
//       logoutMessageOpen: false,
      // How frequently to check for session expiration in milliseconds
      sessionPollInterval: 1000,
      // How many minutes the session is valid
      sessionExpiration: 10,
      // How many minutes before session prompt
      sessionWarning: 8,
      user_lang: {}
    }
  },
  created() {
    this.initSessionMonitor();
    // check user language and assign corresponding label object
    var self = this
    setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
    EventBus.$on('lang', function (language) {
      self.user_lang = self.lang_obj[language]
    })
  },
  methods: {
    assignUserLang() {
      var self = this
      self.user_lang = self.lang_obj[this.lang]
    },
    oktaSignOut() {
      okta.oktaSignOut();
      storage.clearAll();
    },
    initSessionMonitor() {
      this.sessionLastActivity = new Date();
      this.setSessionPollingInterval();
      this.registerSessionTimeoutEvents(this.sessionEventResponse);
    },
    setSessionPollingInterval() {
      this.sessionIntervalID = setInterval(this.checkSessionInterval, this.sessionPollInterval);
    },
    clearSessionPollingInterval() {
      clearInterval(this.sessionIntervalID);
    },
    sessionEventResponse() {
      if (!this.sessionDialogOpen) {
        this.sessionLastActivity = new Date();
      }
    },
    sessionLogout() {
      if (!this.sessionDialogOpen) {
        this.oktaSignOut()
      }
    },
    registerSessionTimeoutEvents(eventResponseFunction) {
      var target = document.body;
      // reset timeout for touch events
      target.addEventListener('touchstart', eventResponseFunction, false);
      // reset timeout for mouse events
      target.addEventListener('keypress', eventResponseFunction, false);
      target.addEventListener('keyup', eventResponseFunction, false);
      target.addEventListener('keydown', eventResponseFunction, false);
      // reset timeout for mouse events
      target.addEventListener('mouseenter', eventResponseFunction, false);
      target.addEventListener('mouseover', eventResponseFunction, false);
      target.addEventListener('mousemove', eventResponseFunction, false);
      target.addEventListener('mousedown', eventResponseFunction, false);
      target.addEventListener('mouseup', eventResponseFunction, false);
      target.addEventListener('click', eventResponseFunction, false);
      target.addEventListener('dblclick', eventResponseFunction, false);
    },
    checkSessionInterval() {
      var now = new Date();
      var diff = now - this.sessionLastActivity;
      var diffMins = (diff / 1000 / 60);
      if (diffMins >= this.sessionWarning) {
        // show warning before expiration
        // stop the timer
        this.clearSessionPollingInterval();
        $('#sessionLogoutModal').modal('show');
        this.sessionDialogOpen = true;
      } else if (diffMins >= this.sessionExpiration) {
        this.sessionLogout();
      }
    },
    clickLogoutYes() {
      $('#sessionLogoutModal').modal('hide');
      this.sessionDialogOpen = false;
      var now = new Date();
      var diff = now - this.sessionLastActivity;
      var diffMins = (diff / 1000 / 60);
      if (diffMins >= this.sessionExpiration) {
        $('#logoutMessageModal').modal('show');
        // this.logoutMessageOpen = true;
        // logout delay of 2 seconds
        setTimeout(() => {
          this.sessionLogout();
        }, 1000);
      } else {
        this.setSessionPollingInterval();
        this.sessionLastActivity = new Date();
      }
    },
    clickLogoutNo() {
      this.sessionDialogOpen = false;
      this.sessionLogout();
    }
//     logoutMessageClose() {
//       this.sessionDialogOpen = false;
//       $('#logoutMessageModal').modal('hide');
//       this.sessionLogout();
//     }
  }
}
</script>
<style scope>
body {
    /* padding-top:64px; */
}
.modal-content {
    -webkit-border-radius: 0;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 0;
    -moz-background-clip: padding;
    border-radius: 6px;
    background-clip: padding-box;
    -webkit-box-shadow: 0 0 40px rgba(0,0,0,.5);
    -moz-box-shadow: 0 0 40px rgba(0,0,0,.5);
    box-shadow: 0 0 40px rgba(0,0,0,.5);
    color: #000;
    background-color: #fff;
    border: rgba(0,0,0,0);
}
.modal-message .modal-body, .modal-message .modal-footer, .modal-message .modal-header, .modal-message .modal-title {
    background: 0 0;
    border: none;
    margin: 0;
    padding: 0 20px;
    text-align: center!important;
}
.modal-message .modal-title {
    font-size: 1.5rem;
    color: #737373;
    margin-bottom: 3px;
}
.modal-message .modal-body {
    color: #737373;
    padding-top: 20px;
}
.modal-message .modal-header {
    color: #fff;
    margin-bottom: 10px;
    padding: 15px;
}
.modal-message .modal-header .fa,
.modal-message .modal-header
.glyphicon, .modal-message
.modal-header .typcn, .modal-message .modal-header .wi {
    font-size: 3rem;
}
.modal-message .modal-footer {
    margin: 25px 0 20px;
    padding-bottom: 10px;
}
.modal-message.modal-warning .modal-header {
    color: #f4b400;
    border-bottom: 3px solid #ffce55;
}
</style>



// WEBPACK FOOTER //
// SessionTimeout.vue?2d0a6309